export default "__VITE_ASSET__205cdc87__"